import React from 'react';

import { connect } from 'react-redux';

import { Link } from 'react-router-dom';


import { editContract } from '../actions';

const ContractSingle = (props) => {

    if (props.id <= 0) {
        return <div className="loader"></div>;
    }

    var contractStatus = 'Obehandlad';
    switch (props.status) {
        case 1: contractStatus = 'Betald'; break;
        case 2: contractStatus = 'Arkiverad';break;
        case 3: contractStatus = 'Borttagen'; break;

    }

    return <div>
        <div className="row">
            <div className="col">
                <div className="row">
                    <div className="col">
                        <h1><Link to="/contracts" className="ml-2"><i
                            className="fa-light fa-arrow-left small"></i></Link> Kontrakt</h1>
                    </div>

                </div>
                <br />
                <table className="table contract-table">
                    <thead>
                        <tr>
                            <th colSpan={2}>Kontraktuppgifter</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-right">Status</td><td>
                                <div className="form-group">
                                    <div className="select">
                                        <select className={ props.status == 0  ? 'form-control text-danger' : 'form-control'} value={props.status} onChange={props.onStatusChange.bind(null, props.id)}>
                                            <option value="0">Obehandlad</option>
                                            <option value="1">Betald</option>
                                            <option value="2">Arkiverad</option>
                                            <option value="3">Borttagen</option>
                                        </select>
                                    </div>
                                </div>
                            {props.loadingStatus && <div className="loader small"></div>}
                            </td>
                        </tr>
                        <tr>
                            <td className="text-right">Kontraktnummer</td><td>{props.id}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Kontraktdatum</td><td>{props.date}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Utgångsdatum</td><td>{props.expiration}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Personnummer</td><td>{props.ssn}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Namn</td><td>{props.name}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Address</td>
                            <td>{props.address}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Postnummer</td>
                            <td>{props.postal_code}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Stad</td>
                            <td>{props.city}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Telefon</td>
                            <td>{props.phone}</td>
                        </tr>
                        <tr>
                            <td className="text-right">E-postadress</td>
                            <td>{props.email}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Plats</td><td>{props.location}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Bank</td><td>{props.payment.bank}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Clearing</td><td>{props.payment.clearing}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Konto</td><td>{props.payment.account}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Kompensation</td><td>{props.compensation} kr</td>
                        </tr>
                        <tr>
                            <td className="text-right">Signatur</td><td><img src={props.signature} /></td>
                        </tr>
                        <tr>
                            <td className="text-right">Avtalsvillkor</td><td>{props.eula}</td>
                        </tr>
                    </tbody>
                </table>

                {props.models && props.models.map((model, i) => {
                    return <table className="table contract-table">
                        <thead>
                        <tr>
                            <th colSpan={2}>Modelluppgifter ({i+1})</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="text-right">Namn</td>
                            <td>{model.name}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Address</td>
                            <td>{model.address}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Postnummer</td>
                            <td>{model.postal_code}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Stad</td>
                            <td>{model.city}</td>
                        </tr>
                        <tr>
                            <td className="text-right">Telefon</td>
                            <td>{model.phone}</td>
                        </tr>
                        <tr>
                            <td className="text-right">E-postadress</td>
                            <td>{model.email}</td>
                        </tr>
                        </tbody>
                    </table>
                })}
            </div>
        </div>

    </div>
}

export default connect(state => state.contractSingleState, (dispatch) => {
    return {
        onStatusChange: (id, e) => {
            editContract(dispatch, id, parseInt(e.target.value));
        }
    }
})(ContractSingle);